import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { PreSignedRequest, PreSignedURL } from '../_interfaces/signed-url';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private apiService: ApiService, private http: HttpClient) {
  }

  async getPreSignedUrl(params: PreSignedRequest): Promise<PreSignedURL> {
    const preSignedUrl = await this.apiService.generatePreSignedUrl(params);
    preSignedUrl.contentType = params.contentType;
    return preSignedUrl;
  }

  getEventMessage(event: HttpEvent<any>, resolve: any): any {
    switch (event.type) {
      case HttpEventType.Sent:
        console.log(`Uploading file...`);
        return {
          progress: 0,
          message: `Uploading file.`
        };
      case HttpEventType.UploadProgress:
        const uploadProgress = Math.round(100 * event.loaded / (event.total || 1));
        console.log(`File is ${uploadProgress}% uploaded.`);
        return { message: `File is ${uploadProgress}% uploaded.`, progress: uploadProgress };
      case HttpEventType.Response:
        console.log(`File was completely uploaded!`);
        resolve({ message: `File was completely uploaded!`, progress: 100 });
        return { message: `File was completely uploaded!`, progress: 100 };
      default:
        console.log(`Unexpected upload event: ${event.type}.`);
        return { message: `Unexpected upload event: ${event.type}.` };
    }
  }

  uploadFile(params: PreSignedURL, file: File): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({ 'Content-Type': params.contentType });
    const req = new HttpRequest('PUT', params.signedRequest, file, {
      headers, reportProgress: true
    });
    return this.http.request(req).pipe(
      tap(event => {
        if (event.type === HttpEventType.UploadProgress || event.type === HttpEventType.Response) {
          this.getEventMessage(event, () => {
          });
        }
      }),
      catchError((error) => {
        console.error('Upload error:', error);
        return throwError(error);
      })
    );
  }

  async uploadImageAWS(params: PreSignedRequest, imageFile: File): Promise<PreSignedURL> {
    const preSigned = await this.getPreSignedUrl(params);
    await new Promise((resolve, reject) => {
      this.uploadFile(preSigned, imageFile).pipe(
        map(event => this.getEventMessage(event, resolve)),
        tap(message => console.log(message)),
        catchError((err) => {
          reject(err);
          return throwError(err);
        })).subscribe();
    });
    return preSigned;
  }
}
